import { useState, useEffect, useContext, useRef } from "react";
import { FaBriefcase, FaUser, FaCalendarAlt } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import { AppContext } from "components/app/RemExprertProvider";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";
import StateBox from "components/ui/controls/state-box/state-box";
import { applyFormat } from "components/ui/ui-helpers";
import { CorrespondanceActivite } from "components/app/RemExpertIntialState";
import _ from "lodash";
import InfoMessage from "components/ui/controls/info-message";

// Styles CSS pour le scrollbar personnalisé
const styles = `
  .custom-scrollbar::-webkit-scrollbar {
    width: 6px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 10px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;

if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}

// Period Card Component
const PeriodCard = ({ period, selected, disabled, onSelect, correspondanceActivite }) => {
  const getActivityIcon = (nature) => {
    if (nature?.includes("Salarie") || nature?.includes("Fonction")) {
      return <FaBriefcase style={{ fontSize: 14, color: "#0d47a1" }} />;
    }
    return <FaUser style={{ fontSize: 14, color: "#0d47a1" }} />;
  };

  return (
    <div
      className="period-card"
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "18px 24px",
        marginBottom: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        border: "1px solid #f0f0f0",
        transition: "all 0.2s ease",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        minHeight: "88px",
        width: "100%",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.12)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
          <div
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              backgroundColor: "#e3f2fd",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "12px",
            }}
          >
            {getActivityIcon(period.Nature)}
          </div>
          <div style={{ flex: 1 }}>
            <h4
              style={{
                margin: 0,
                fontSize: "12px",
                fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                fontWeight: 600,
                color: "#333",
                marginBottom: "4px",
              }}
            >
              {correspondanceActivite[period.Nature] || "Activité non définie"}
            </h4>
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <FaCalendarAlt style={{ fontSize: 10, color: "#666" }} />
                <span
                  style={{
                    fontSize: "10px",
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    color: "#666",
                  }}
                >
                  {applyFormat(period.Debut, "date", "")}
                </span>
              </div>
              <span style={{ color: "#ccc", fontSize: "10px" }}>→</span>
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <FaCalendarAlt style={{ fontSize: 10, color: "#666" }} />
                <span
                  style={{
                    fontSize: "10px",
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    color: "#666",
                  }}
                >
                  {applyFormat(period.Fin, "date", "")}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "32px", flexShrink: 0 }}>
          <StateBox disabled={disabled} value={selected} onClick={onSelect} normal style={{ marginBottom: 0 }} />
        </div>
      </div>
    </div>
  );
};

const AlertLURAModalCumulEmploi = (props) => {
  const context = useContext(AppContext);
  const [currentPage, setCurrentPage] = useState(0);
  const [idsPeriodeLURA, setIdsPeriodeLURA] = useState({});
  const [isValidating, setIsValidating] = useState(false);
  const [validationError, setValidationError] = useState("");
  const validationPending = useRef(false);
  const luraIds = context.state.CumulEmploisIdsLURA;

  useEffect(() => {
    let ids = {};
    if (!props.visible) return;
    luraIds?.forEach((id, index) => {
      if (index === 0) {
        ids[id] = true;
      } else {
        ids[id] = false;
      }
    });
    setIdsPeriodeLURA(ids);
    setValidationError("");
  }, [props.visible, luraIds]);

  const handleCheckIdLURA = (idPeriode) => {
    let ids = _.cloneDeep(idsPeriodeLURA);
    if (validationPending.current) return;
    Object.keys(idsPeriodeLURA).forEach((id) => {
      if (String(idPeriode) === id) {
          ids[id] = true;
      } else {
        ids[id] = false;
      }
    });
    setIdsPeriodeLURA(ids);
  };

  const handleValidateLURA = async () => {
    if (validationPending.current || !Object.values(idsPeriodeLURA).includes(true)) return;
    validationPending.current = true;
    setIsValidating(true);
    setValidationError("");
    let data = _.cloneDeep(context.state);
    data["CumulEmploiCarriere" + props.ClientConjoint] = data["CumulEmploiCarriere" + props.ClientConjoint].filter(
      (periode) => idsPeriodeLURA[String(periode.id)] !== false
    );
    data.CumulEmploiAlertLURA = false;
    data.CumulEmploisIdsLURA = [];
    try {
      // Le retour du calcul met lui-même à jour la visibilité de l'alerte.
      // Ne pas la fermer avant cette réponse, ni masquer une nouvelle alerte.
      await context.handleCalculCER(props.ClientConjoint, data);
    } catch (error) {
      setValidationError("Le calcul n'a pas abouti. Veuillez réessayer.");
    } finally {
      validationPending.current = false;
      setIsValidating(false);
    }
  };

  return (
    <>
      <Pager
        validateDisabled={isValidating || !Object.values(idsPeriodeLURA).includes(true)}
        pages={[
          {
            content: (
              <>
                <Column fill>
                  {validationError && <p role="alert">{validationError}</p>}
                  <CardBox>
                    <Column fill>
                      <Row tpad>
                        <InfoMessage
                    text={
                      <>
                            Les instructions règlementaires sur le calcul de la nouvelle pension dans le cadre de la LURA n'ont pas encore été communiquées par l'Assurance retraite. Par
                            conséquent, nous avons fait le choix d'empêcher la possibilité de saisir une double activité d'indépendant et de salarié. Une modification logicielle sera
                            apportée dès parution de la circulaire.<br/>
                            Dans l'attente de la mise à jour, nous vous invitons à sélectionner l'une des deux périodes que vous souhaitez projeter dans le cadre du CER.
                      </>
                    }
                  />
                      </Row>
                      <Row tpad>
                        <Row fill tpad className="custom-scrollbar" style={{ maxHeight: "500px", overflow: "auto" }}>
                          <Column fill>
                            {context.state["CumulEmploiCarriere" + props.ClientConjoint]?.map((Infos, Index) => {
                              return (
                                luraIds?.some((id) => String(id) === String(Infos.id)) && (
                                  <PeriodCard
                                    key={Index}
                                    period={Infos}
                                    selected={idsPeriodeLURA?.[Infos.id]}
                                    disabled={isValidating}
                                    correspondanceActivite={CorrespondanceActivite}
                                    onSelect={() => {
                                      handleCheckIdLURA(Infos.id);
                                    }}
                                  />
                                )
                              );
                            })}
                          </Column>
                        </Row>
                        <Column></Column>
                      </Row>
                    </Column>
                  </CardBox>
                </Column>
              </>
            ),
          },
        ]}
        page={currentPage}
        onPageChange={(page) => {
          setCurrentPage(page);
        }}
        navButtons={{
          // cancel: {},
          previous: {},
          next: {},
          validate: {
            onClick: handleValidateLURA,
          },
        }}
      />
    </>
  );
};

export default AlertLURAModalCumulEmploi;
